import { styled } from 'styled-components';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition } from '../../../util';
export const CharCount = styled.span.withConfig({
  componentId: "aui__sc-zxp4yk-0"
})(["margin-left:", ";justify-self:flex-start;"], ({
  $textHelperPresent
}) => $textHelperPresent ? '0.75rem' : 'auto');
export const HelperTextWrapper = styled.div.withConfig({
  componentId: "aui__sc-zxp4yk-1"
})(["display:flex;justify-content:space-between;width:100%;box-sizing:border-box;font-size:", ";line-height:130%;-moz-osx-font-smoothing:grayscale;font-weight:", ";padding:0.25rem 0.75rem;background-color:transparent;color:", ";", ";"], getFontSize(1), getFontWeight('base'), ({
  $fieldStatus
}) => $fieldStatus === 'error' ? 'var(--aui-status-error)' : 'var(--aui-on-surface-soft)', createTransition({
  properties: ['color']
}));